import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import {Field} from 'redux-form';

import FormField from 'components/FormField';
import Label from 'components/Label';
import {SearchField, DateField, TextField} from 'components/Fields';
import {BottomRightCustomOverlay} from 'components/DatePicker';

import {validDate} from 'utils/validators';
import {getCurrentMonthFirstDay} from 'utils/datetime';

import {SCHEDULE_TYPES} from 'ducks/tenancy';

import './styles.css';

const BaseFields = ({
  xeroAccountOptions,
  scheduleType,
  fetchXeroTaxRatesForAccount,
  canCreateDraftInvoiceForPastMonths
}) => {
  const forRent = scheduleType === SCHEDULE_TYPES.RENT;

  let datepickerProps: any = undefined;
  const currentMonthFirstDay: any = getCurrentMonthFirstDay();

  if (!canCreateDraftInvoiceForPastMonths) {
    datepickerProps = {
      disabledDays: {before: new Date(currentMonthFirstDay)}
    };
  }

  const DatePickerWithPermissionsOverlay = ({
    children,
    onBlur,
    onFocus,
    tabIndex,
    month // month here is the first day of the current selected month
  }: any) => {
    const shouldShowWarning =
      !canCreateDraftInvoiceForPastMonths &&
      moment(month) < currentMonthFirstDay;

    return (
      <div
        className="DayPickerInput-OverlayWrapper"
        onBlur={onBlur}
        onFocus={onFocus}
        tabIndex={tabIndex}>
        <div className="DayPickerInput-Overlay">
          {children}
          {shouldShowWarning && (
            <div className="colab-centered colab-bold ">
              You do not have the permission!
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="BaseFields">
      <FormField>
        <Label>Date</Label>
        <Field
          name="dateIssued"
          validate={[validDate]}
          component={DateField}
          dayPickerProps={datepickerProps}
          overlayComponent={DatePickerWithPermissionsOverlay}
        />
      </FormField>
      <FormField>
        <Label>Due date</Label>
        <Field
          name="dueDate"
          validate={[validDate]}
          component={DateField}
          dayPickerProps={datepickerProps}
          overlayComponent={DatePickerWithPermissionsOverlay}
        />
      </FormField>
      <FormField>
        <Label>Account</Label>
        <Field
          name="xeroAccount"
          component={SearchField}
          {...{options: xeroAccountOptions}}
          disabled={xeroAccountOptions.length === 1}
          onChange={(opt: any) =>
            fetchXeroTaxRatesForAccount({accountClass: opt.accountClass})
          }
        />
      </FormField>
      {forRent && (
        <React.Fragment>
          <FormField>
            <Label>Reference</Label>
            <Field name="rentReference" component={TextField} />
          </FormField>
          <FormField>
            <Label>Rent start</Label>
            <Field
              name="rentStart"
              validate={[validDate]}
              component={DateField}
              dayPickerProps={datepickerProps}
              overlayComponent={DatePickerWithPermissionsOverlay}
            />
          </FormField>
          <FormField>
            <Label>Rent end</Label>
            <Field
              name="rentEnd"
              component={DateField}
              overlayComponent={BottomRightCustomOverlay}
            />
          </FormField>
        </React.Fragment>
      )}
    </div>
  );
};

export default BaseFields;
